<template>
  <div class="localization">
    <div class="main-wrapper">
      <layout-header></layout-header>
      <layout-sidebarPromotion></layout-sidebarPromotion>
      <div class="page-wrapper">
        <!-- Page Content -->
        <div class="content container-fluid">
          <div class="row">
            <div class="col-md-12">
              <!-- Page Header -->
              <div class="page-header">
                <div class="row">
                  <!-- {{profileArr}} -->
                  <div class="col-sm-12">
                    <h3 class="page-title">Commission - Affiliate Program</h3>
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-md-12">
                  <div class="card-group m-b-30">
                    <div class="card">
                      <div class="card-body">
                        <div class="d-flex justify-content-between mb-3">
                          <div>
                            <span class="d-block">New Users</span>
                          </div>
                          <div v-show="false">
                            <span class="text-success">0%</span>
                          </div>
                        </div>
                        <h3 class="mb-3">{{thisMonth.num_join}}</h3>

                        <p class="mb-0">
                          Previous Month
                          <span class="text-muted">{{lastMonth.num_join}}</span>
                        </p>
                      </div>
                    </div>
                    <div class="card">
                      <div class="card-body">
                        <div class="d-flex justify-content-between mb-3">
                          <div>
                            <span class="d-block">Licenses</span>
                          </div>
                          <div v-show="false">
                            <span class="text-danger">0%</span>
                          </div>
                        </div>
                        <h3 class="mb-3">{{thisMonth.num_license}}</h3>

                        <p class="mb-0">
                          Previous Month
                          <span class="text-muted">{{lastMonth.num_license}}</span>
                        </p>
                      </div>
                    </div>
                    <div class="card">
                      <div class="card-body">
                        <div class="d-flex justify-content-between mb-3">
                          <div>
                            <span class="d-block">Omzet</span>
                          </div>
                          <div v-show="false">
                            <span class="text-success">0%</span>
                          </div>
                        </div>
                        <h3 class="mb-3">Rp {{formatPriceRupiah(thisMonth.omzet_license)}}</h3>

                        <p class="mb-0">
                          Previous Month
                          <span
                            class="text-muted"
                          >Rp {{formatPriceRupiah(lastMonth.omzet_license)}}</span>
                        </p>
                      </div>
                    </div>
                    <div class="card">
                      <div class="card-body">
                        <div class="d-flex justify-content-between mb-3">
                          <div>
                            <span class="d-block">Payable Amount</span>
                          </div>
                          <div v-show="false">
                            <span class="text-success">0%</span>
                          </div>
                        </div>
                        <h3 class="mb-3">Rp {{formatPriceRupiah(payableAmount)}}</h3>
                        <p class="mb-0">
                          <small
                            class="text-muted"
                          >Komisi yang belum dibayar dan akan diperbaharui dalam waktu 1x24 jam.</small>
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="card tab-box">
                <div class="row user-tabs">
                  <div class="col-lg-12 col-md-12 col-sm-12 line-tabs">
                    <ul class="nav nav-tabs nav-tabs-bottom">
                      <li class="nav-item col-sm-3">
                        <a class="nav-link active" data-toggle="tab" href="#licenses">Purchase Order</a>
                      </li>
                      <li class="nav-item col-sm-3">
                        <a class="nav-link" data-toggle="tab" href="#users">Users</a>
                      </li>
                      <li class="nav-item col-sm-3">
                        <a class="nav-link" data-toggle="tab" href="#withdrawal">Withdrawal</a>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-lg-12">
                  <div class="tab-content profile-tab-content">
                    <!-- Projects Tab -->
                    <div id="licenses" class="tab-pane fade show active">
                      <div class="row">
                        <div class="col-lg-12 col-sm-12 col-md-12 col-xl-12">
                          <order-list />
                        </div>
                      </div>
                    </div>
                    <div id="users" class="tab-pane fade">
                      <div class="row">
                        <div class="col-lg-12 col-sm-12 col-md-12 col-xl-12">
                          <member-list />
                        </div>
                      </div>
                    </div>
                    <div id="withdrawal" class="tab-pane fade">
                      <div class="row">
                        <div class="col-lg-12 col-sm-12 col-md-12 col-xl-12">
                          <withdraw-list />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- /Page Content -->
      </div>
      <!-- /Page Wrapper -->
    </div>
  </div>
</template>

<script>
import OrderList from "./components/orderList.vue";
import WithdrawList from "./components/withdrawList.vue";
import MemberList from "./components/memberList.vue";

import { formatPriceRupiah } from "@/utils/helper";
// import LayoutSidebarPromotion from "@/components/layouts/SidebarPromotion.vue";
import LayoutSidebarPromotion from "@/components/layouts/Sidebar.vue";

export default {
  components: {
    WithdrawList,
    OrderList,
    MemberList,
    LayoutSidebarPromotion
  },
  computed: {
    memberSession() {
      return this.$store.state.login.memberSession;
    },
    
  },
  data() {
    return {
      isLoadingBalance: false,
      payableAmount: 0,
      bankArr: {
        member_bank_id: "",
        member_bank_city: "",
        member_bank_branch: "",
        member_bank_account_no: "",
        member_bank_account_name: "",
        update_datetime: 0
      },
      appTitle: process.env.VUE_APP_TITLE,
      isLoading: false,

      isLoadingStatThisMonth: false,
      thisMonth: {
        id: 0,
        member_id: "0",
        num_join: 0,
        num_license: 0,
        omzet_license: 0,
        start_datetime: 0,
        end_datetime: 0
      },
      isLoadingStatLastMonth: false,
      lastMonth: {
        id: 0,
        member_id: "0",
        num_join: 0,
        num_license: 0,
        omzet_license: 0,
        start_datetime: 0,
        end_datetime: 0
      }
    };
  },
  async created() {
    this.statThisMonth();
    this.statLastMonth();
    this.getBalance();
  },
  methods: {
    formatPriceRupiah(value) {
      return formatPriceRupiah(value);
    },
    statLastMonth() {
      this.isLoadingStatLastMonth = true;
      this.$store
        .dispatch("referral/statLastMonth")
        .then(response => {
          this.lastMonth = response.data;
          this.isLoadingStatLastMonth = false;
        })
        .catch(() => {
          this.isLoadingStatLastMonth = false;
        });
    },
    statThisMonth() {
      this.isLoadingStatThisMonth = true;
      this.$store
        .dispatch("referral/statThisMonth")
        .then(response => {
          this.thisMonth = response.data;
          this.isLoadingStatThisMonth = false;
        })
        .catch(() => {
          this.isLoadingStatThisMonth = false;
        });
    },
    getBalance() {
      this.isLoadingBalance = true;
      this.$store
        .dispatch("referral/getBalance")
        .then(response => {
          this.payableAmount = response.data;
          this.isLoadingBalance = false;
        })
        .catch(() => {
          this.isLoadingBalance = false;
        });
    }
  },
  mounted() {
    // Select 2
    if ($(".select").length > 0) {
      $(".select").select2({
        minimumResultsForSearch: -1,
        width: "100%"
      });
    }
    // Multiselect
    if ($("#customleave_select").length > 0) {
      $("#customleave_select").multiselect();
    }
    if ($("#edit_customleave_select").length > 0) {
      $("#edit_customleave_select").multiselect();
    }
    if ($(".floating").length > 0) {
      $(".floating")
        .on("focus blur", function(e) {
          $(this)
            .parents(".form-focus")
            .toggleClass(
              "focused",
              e.type === "focus" || this.value.length > 0
            );
        })
        .trigger("blur");
    }
  },
  name: "referral"
};
</script>


// WEBPACK FOOTER //
// src/views/referral/commission.vue